import React from "react";
import { PromoCodeEditor } from "../features/promo-codes";
import { withRestaurantId } from "../shared/components/layout";

const PromoCodeEditorWithId = withRestaurantId(PromoCodeEditor);

const PromoCodesPage: React.FC = () => {
  return <PromoCodeEditorWithId />;
};

export default PromoCodesPage;
